import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

export default function EnquiryTimeline({ data }) {
  return (
    <Timeline position="alternate">
      {/* Display data as alternating timeline */}
      {data.map((enquiry, index) => (
        <TimelineItem key={index}>
          <TimelineOppositeContent
            sx={{ m: "1rem 0 auto" }}
            align="right"
            variant="body2"
            color="text.secondary"
          >
            <Typography variant="body2" color="text.secondary">
              {
                // convert the timestamp to a readable date
                new Date(enquiry.timestamp).toLocaleDateString("en-IN", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              }
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot
              //   make the dot color based on the next follow up date if date is in the past then make it red else make it green
              sx={{
                backgroundColor:
                  new Date(enquiry.nextFollowUpDate) < new Date()
                    ? "#ff0039"
                    : "#3671D5",
              }}
            >
              <Typography
                variant="h6"
                component="span"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  lineHeight: "1.2rem",
                  textAlign: "center",
                  width: "1.2rem",
                  height: "1.2rem",
                }}
              >
                {index + 1}
              </Typography>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent
            sx={{
              m: "0.4rem 0 auto",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="h6" component="span">
                Call Status : {enquiry?.callStatus}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                className="font-normal"
              >
                Customer Response : {enquiry.customerResponse}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                className="font-normal"
              >
                Remarks : {enquiry.remarks}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                className="font-bold"
              >
                <Typography
                  variant="body2"
                  component={"span"}
                  className="font-semibold"
                >
                  Follow-up on :{" "}
                </Typography>
                {new Date(enquiry.nextFollowUpDate).toLocaleDateString(
                  "en-IN",

                  {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }
                )}
              </Typography>
            </Box>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}
